var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 26.5 26.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19811"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19810"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19737",
  transform: "translate(-70.709 -600.75)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#f1595d",
  stroke: "#f1595d",
  "data-name": "Ellipse 1634",
  transform: "translate(71.459 601.5)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  "data-name": "Group 19736"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80.176 609.01a1.08 1.08 0 0 1 1.08-1.08",
  "data-name": "Path 27399"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.176 618.734a1.08 1.08 0 0 0 1.08 1.08",
  "data-name": "Path 27400"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.176 618.734v-9.724",
  "data-name": "Line 1681"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.258 607.93h4.322",
  "data-name": "Line 1682"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.258 619.814h4.322",
  "data-name": "Line 1683"
}), /*#__PURE__*/React.createElement("path", {
  d: "m85.039 611.172 2.701 2.701",
  "data-name": "Line 1684"
}), /*#__PURE__*/React.createElement("path", {
  d: "m85.039 616.572 2.701-2.701",
  "data-name": "Line 1685"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.555 613.871h5.186",
  "data-name": "Line 1686"
})))))));
export { SvgLogout3 as ReactComponent };
export default __webpack_public_path__ + "static/media/logout3.5c54724e17f954b8565d2a346237174a.svg";